import systemApi from '@/api/system';
import {Message} from 'element-ui';
import router from '@/router'

const user = {
    state: {
        account: undefined,//用户
        account_menus: [],//所有用户菜单（基于用户菜单、用户角色菜单合并产生）
        menu_icons: {"员工管理": "fa-newspaper-o ", "客户预约": "fa-building-o", "门店管理": "fa-building-o"}
    },

    mutations: {
        SET_ACCOUNT: (state, account) => {
            state.account = account
        },
        SET_ACCOUNT_MENUS: (state, account_menus) => {
            state.account_menus = account_menus
        }
    },

    actions: {
        // 登出
        logout({commit, state}) {
            commit("SET_ACCOUNT", undefined);
            localStorage.setItem('token', null)
            router.push({ name: '登录'});
        },
        //查询已登录用户信息(含用户、角色、用户组)
        queryLoginData({commit, state}) {
            let getAccount = new Promise((resolve, reject) => {
                let token = localStorage.getItem('token')
                if(token==null || token=="null"){
                    Message.warning("登录信息丢失，请重新登录")
                    router.push({ name: '登录'});
                    return
                }
                systemApi.queryLoginUserData().then(res => {
                    if(res.data.code=='200'){
                        let account = res.data.data;
                        console.log(account)
                        localStorage.setItem('userType', account.userType)
                        if (account) {
                            commit('SET_ACCOUNT', account);
                            resolve(account);
                        }
                    }else if(res.data.code=='402'){
                        router.push({ name: '登录'});
                    }
                    
                })
            })
            let getMenus = new Promise((resolve, reject) => {
                let menus =  [
                    {
                        id: 1,
                        name: '客户预约'
                    },{
                        id: 2,
                        name: '员工管理'
                    },{
                        id: 3,
                        name: '门店管理'
                    }
                ];
                resolve(menus);
               
            })
            return new Promise((resolve, reject) => {
                Promise.all([getAccount]).then((results) => {
                    let account = results[0];
                    if (!account) {
                        resolve();
                    }
                    //请求账号可用全部菜单
                    Promise.all([getMenus]).then((results) => {
                        let menus = results[0];
                        console.log(menus)
                        if (menus) {
                            menus.forEach(menu => {
                                state.menu_icons[menu.name] && (menu.icon = state.menu_icons[menu.name])
                            });
                            commit('SET_ACCOUNT_MENUS', menus);
                        } else {
                            Message.warning("菜单信息缺失，请联系管理员重新配置")
                        }
                        resolve(1);
                    })
                })
            })
        }
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js